import { render, staticRenderFns } from "./Consult.vue?vue&type=template&id=509ca506&scoped=true"
import script from "./Consult.vue?vue&type=script&lang=js"
export * from "./Consult.vue?vue&type=script&lang=js"
import style0 from "./Consult.vue?vue&type=style&index=0&id=509ca506&prod&lang=scss&scoped=true"
import style1 from "./Consult.vue?vue&type=style&index=1&id=509ca506&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ca506",
  null
  
)

export default component.exports